import { atom } from "recoil";
import { IOfficeStatusDetails } from "../types";

export const addStateOfficeStatusDetails = atom({
  key: "addStateOfficeStatusDetails",
  default: false,
});
export const editStateOfficeStatusDetails = atom({
  key: "editStateOfficeStatusDetails",
  default: false,
});
export const rowEditOfficeStatusDetails = atom<IOfficeStatusDetails | undefined>({
  key: "rowEditOfficeStatusDetails",
  default: undefined,
});

export const selectedRowsStateOfficeStatusDetails = atom<IOfficeStatusDetails[]>({
  key: "selectedRowsStateOfficeStatusDetails",
  default: [],
});

export const officeStatusDetailsFilterText = atom({
  key: "officeStatusDetailsFilterText",
  default: "",
});

export const savingOfficeStatusDetails = atom({
  key: "savingOfficeStatusDetails",
  default: false,
});
export const officeStatusDetailsFetching = atom({
  key: "officeStatusDetailsFetching",
  default: true,
});
export const officeStatusDetailsReFetching = atom({
  key: "officeStatusDetailsReFetching",
  default: true,
});

